'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AudioBleep = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.listenForHighlights = listenForHighlights;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AudioBleep = exports.AudioBleep = function () {
    function AudioBleep() {
        (0, _classCallCheck3.default)(this, AudioBleep);

        this.lastPlayed = 0;

        this.audio = document.createElement('audio');
        var source = document.createElement('source');

        if (this.audio.canPlayType('audio/mpeg;')) {
            source.type = 'audio/mpeg';
            source.src = 'static/highlight.mp3';
        } else {
            source.type = 'audio/ogg';
            source.src = 'static/highlight.ogg';
        }

        this.audio.appendChild(source);
    }

    (0, _createClass3.default)(AudioBleep, [{
        key: 'play',
        value: function play() {
            if (!this.lastPlayed || Date.now() - this.lastPlayed > 2000) {
                this.audio.play();
                this.lastPlayed = Date.now();
            }
        }
    }]);
    return AudioBleep;
}();

function listenForHighlights(state) {
    var bleep = new AudioBleep();

    state.$on('message.new', function (message, buffer) {
        if (buffer.setting('mute_sound')) {
            return;
        }

        var ignoreTypes = ['connection', 'traffic', 'nick'];
        if (ignoreTypes.indexOf(message.type) > -1) {
            return;
        }

        if (message.ignore) {
            return;
        }

        var isHighlight = message.isHighlight;
        var isActiveBuffer = state.getActiveBuffer() === buffer;
        var inFocus = isActiveBuffer && state.ui.app_has_focus;

        if (isHighlight || buffer.isQuery() && !inFocus) {
            bleep.play();
        }
    });
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["AudioBleep"]
window._kiwi_exports.libs.AudioBleep = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/AudioBleep.js
// module id = 8cy9
// module chunks = 1